export const useIsMobile = () => {
  if (window.AIRSLATE_ENV_CONFIGURATION) {
    return !!window.AIRSLATE_ENV_CONFIGURATION.IS_MOBILE;
  }

  return window.innerWidth < 768;
};
